import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoHide: Boolean,
    duration: { type: Number, default: 5000 }
  }

  initialize() {
  }

  connect() {
    this.show()
  }

  disconnect() {
  }

  show() {
    // Small delay to ensure initial state is rendered
    requestAnimationFrame(() => {
      this.element.classList.remove('translate-x-full', 'opacity-0')
      this.element.classList.add('translate-x-0', 'opacity-100')
    })

    // Auto-hide after 5 seconds
    setTimeout(() => {
      this.close()
    }, 5000)
  }

  close() {
    this.element.classList.remove('translate-x-0', 'opacity-100')
    this.element.classList.add('translate-x-full', 'opacity-0')
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
} 
